export const synergyStaticDataLayer = {
  subsidiary_name: 'axa_partners',
  business_line: 'motor_and_home_solutions',
  business_unit: 'customer_and_solutions',
};
